export default ({ actionField = {}, currencyCode = '', balance = null, impressions = [] } = {}) => {
  return balance === null ? {
    event: 'productImpression',
    ecommerce: {
      actionField,
      currencyCode,
      impressions,
    },
  } : {
    event: 'productImpression',
    pointsCP: balance,
    ecommerce: {
      actionField,
      currencyCode,
      impressions,
    },
  };
};
